import React, { Fragment } from 'react';
import styled from 'styled-components';
import {Block, BlockStyle} from './Block';

const PlaceholderStyle = styled.div`
    height: 100px;
    background-image: url(${process.env.PUBLIC_URL}/assets/droparea.png);
`

const BlockBackgroundStyle = styled(BlockStyle)`
    ${props=>props.isDragging ? `box-shadow: 30px 30px 30px rgba(0, 0, 0, 0.5);
                                position: absolute;
                                z-index: 100;
                                width: 100%;` : null}
    background-color: ${props=>props.backgroundColor};

`;

export class BlockBackgroundProxy extends React.Component {
    componentDidMount(){
        this.props.reference.current.style.cssText = this.props.styleText;
      }
    componentDidUpdate(prevProps){
        if(prevProps.styleText !== this.props.styleText){
            this.props.reference.current.style.cssText = this.props.styleText;
        }
    }

    render(){
        return <BlockBackgroundStyle
            id={this.props.id}
            key={this.props.id}
            backgroundColor={this.props.backgroundColor}
            isDragging={this.props.isDragging}
            ref={this.props.reference}>
                {this.props.children}
            </BlockBackgroundStyle>
        }
}


export class BlockBackground extends Block{
    constructor(props){
        super(props);
        this.type = 'Background';
        this.color = '#ffffff';
    }

    unpack(data){
        super.unpack( data );

        let color = data['color'];
        if(color === undefined){
            color = '#ffffff';
        }
        this.color = color;
    }

    pack(){
        let data = super.pack();
        data['color'] = this.color;
        return data;
    }

    setOffset( value ){
        super.setOffset( value );
        if(this.ref.current){
            this.ref.current.style.left = value.x + 'px';
            this.ref.current.style.top = value.y + 'px';
        }
    }
    renderOverlay(ctx){
        if(this.isDragging){
            return;
        }

        super.renderOverlay(ctx);
    }

    renderView(){
        let placeholder = <PlaceholderStyle>

        </PlaceholderStyle>

        return (
        <Fragment key={this.id}>
            { this.isDragging ? placeholder : null}
            <BlockBackgroundProxy
                id={this.id}
                key={this.id}
                reference={this.ref}
                styleText={this.style()}
                backgroundColor={this.color}
                isDragging={this.isDragging}
                >
                    {
                        this.children.map((child)=>{
                        return child.renderView();
                        })
                    }

            </BlockBackgroundProxy>
        </Fragment>
        )
    }
}